import { Checkbox, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatchControl extends Layout {
    checkboxAllowReservedMovements: Checkbox;
    checkboxApplyFeasibility: Checkbox;
    checkboxDriverAssignments: Checkbox;
    checkboxEmptyCheckCall: Checkbox;
    checkboxEnableEmptyDistOverride: Checkbox;
    checkboxEnableEstimatedPay: Checkbox;
    checkboxEnforceHubReadings: Checkbox;
    checkboxEnforceRegulatory: Checkbox;
    checkboxExcludeOrderTypes: Checkbox;
    checkboxExcludeRevenueCodes: Checkbox;
    checkboxFeasibilityPromptAvailHr: Checkbox;
    checkboxIncludeDedicatedChoice: Checkbox;
    checkboxIncludeHighvalueChoice: Checkbox;
    checkboxPalletTracking: Checkbox;
    checkboxRecordDriverHours: Checkbox;
    checkboxRecordPta: Checkbox;
    checkboxRecordPtaWeb: Checkbox;
    checkboxReqUnassignReason: Checkbox;
    checkboxRequireDeparture: Checkbox;
    checkboxRequirePickupTrailer: Checkbox;
    checkboxTrailerContinuity: Checkbox;
    checkboxTrlAssignCheck: Checkbox;
    dataheaderOps: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacerGap: HorizontalSpacer;
    labelCanadaRules: Label;
    labelHOSHeader: Label;
    labelPosition: Label;
    labelUSARules: Label;
    panel1: Panel;
    panelAutoHomeFields: Panel;
    panelEquip1: Panel;
    panelEquip2: Panel;
    panelEquip3: Panel;
    panelFeasibility2: Panel;
    panelFeasibility: Panel;
    panelHOS: Panel;
    panelLMCheckboxes1: Panel;
    panelLMCheckboxes2: Panel;
    panelMaintenanceInfo: Panel;
    sourceDispatchControl: DataSource;
    switchAutoHomeDriverdt: Switch;
    switchEnableAutoHome: Switch;
    switchInclInspectTime: Switch;
    switchInclRefuelTime: Switch;
    tabAutoHome: Tab;
    tabDedicatedBilling: Tab;
    tabEquipmentSettings: Tab;
    tabFeasibility: Tab;
    tabInprogressSettings: Tab;
    tabInteractive: Tab;
    tabLoadMatch: Tab;
    tabMaintenance: Tab;
    tabMobileCommControl: Tab;
    tabMultiSelect: Tab;
    tabOperations: Tab;
    tabServiceIncidents: Tab;
    tabsetMain: Tabset;
    textboxAutoHomeCallin: Textbox;
    textboxAutoHomeRadius: Textbox;
    textboxAutoHomeStarthrs: Textbox;
    textboxAvgSpeed: Textbox;
    textboxBracket1: Textbox;
    textboxBracket2: Textbox;
    textboxBracket3: Textbox;
    textboxBreakHours: Textbox;
    textboxCanadaBreakHours: Textbox;
    textboxCanadaDrivingHours: Textbox;
    textboxCanadaOndutyHours: Textbox;
    textboxCashDay: Textbox;
    textboxChoiceDriverTypes: Textbox;
    textboxClaimAck: Textbox;
    textboxDaysForView: Textbox;
    textboxDeadheadTarget: Textbox;
    textboxDefaultLoadtime: Textbox;
    textboxDefaultRevShareViewDays: Textbox;
    textboxDefaultUnloadtime: Textbox;
    textboxDispatchBy: Textbox;
    textboxDistComunication: Textbox;
    textboxDriverHome: Textbox;
    textboxDriverHoursFormat: Textbox;
    textboxDrivingHours: Textbox;
    textboxEquipRequirement: Textbox;
    textboxFeasibilityDwellHithresh: Textbox;
    textboxFeasibilityDwellLothresh: Textbox;
    textboxFeasibilityMph: Textbox;
    textboxFeasibilityRateBasis: Textbox;
    textboxFeasibilityZmitMinTime: Textbox;
    textboxFindnearMethod: Textbox;
    textboxFuelDistance: Textbox;
    textboxGenerateCheckCall: Textbox;
    textboxGracePeriod: Textbox;
    textboxInspectTime: Textbox;
    textboxLoadMatchRateBasis: Textbox;
    textboxMaintAMiles: Textbox;
    textboxMaintARange: Textbox;
    textboxMaintBMiles: Textbox;
    textboxMaintBRange: Textbox;
    textboxMaxAAssignSelections: Textbox;
    textboxMaxAHoldSelections: Textbox;
    textboxMaxALinkSelections: Textbox;
    textboxMaxAUnassignSelections: Textbox;
    textboxMaxAUpdateSelections: Textbox;
    textboxMaxRevenue: Textbox;
    textboxMaxSendLoadSelections: Textbox;
    textboxMaximumDeadhead: Textbox;
    textboxNearMove: Textbox;
    textboxNewDriver1: Textbox;
    textboxNewDriver2: Textbox;
    textboxNumberDriver: Textbox;
    textboxNumberTrailer: Textbox;
    textboxOndutyHours: Textbox;
    textboxOrderTypeChoice: Textbox;
    textboxPickupWarning: Textbox;
    textboxPositionDisplay: Textbox;
    textboxPositionFormat: Textbox;
    textboxPositionLastLocation: Textbox;
    textboxPreferedTemp: Textbox;
    textboxPromptRevenueShareWhen: Textbox;
    textboxRecordService: Textbox;
    textboxRefuelTime: Textbox;
    textboxRevenueCodeChoice: Textbox;
    textboxStoptimeMsg: Textbox;
    textboxTieEmptyMovesTo: Textbox;
    textboxUnassignmentMsg: Textbox;
    textboxdeliveryWarning: Textbox;
}
